<template>
    <div>
        <vx-card>
            <div slot="no-body" class="tabs-container px-6 pt-6">

                <div id="branch-tab-info">
                    <div class="flex-grow">
                        <div class="vx-col md:w-1/4 sm:w-auto mr-4">
                            <label class="vs-input--label">{{$t('workShift.branch')}}</label>
                            <span class="text-danger">*</span>
                            <v-select class="" :disabled="isUpdate" v-model="selectedOrganizationBranch"
                                      :clearable="false" :options="organizationBranchOptions">
                                <span slot="no-options"> {{$t('menuOrganization.emptyList')}} </span>
                            </v-select>
                        </div>
                    </div>

                    <div class="vx-row">
                        <div class="vx-col w-full mb-4 mt-4">
                            <h5>{{$t('workShift.setting')}}</h5>
                        </div>
                    </div>
                    <div class="vx-row md:mb-1 mb-4">
                        <div class="vx-col lg:w-1/4 w-full">
                            <label class="vs-input--label">{{$t('workShift.groupName')}}</label>
                            <span class="text-danger">*</span>
                            <vs-input class="w-full" data-vv-validate-on="blur" name="groupName"
                                      v-model="groupName" v-validate="'required|min:4|max:100'"/>
<!--                            <span class="text-danger text-sm">{{ errors.first('groupName') }}</span>-->
                        </div>
                    </div>
                    <div class="vx-col mt-5" v-if="!isUpdate">
                        <feather-icon icon="PlusIcon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                                      @click="addNewRecord(indexWorkshift)"/>
                    </div>

                    <div :key="index" v-for="(item, index) in workShiftSetting" class="mt-3">
                        <div class="vx-row md:mb-1 mb-4">
                            <div class="vx-col lg:w-1/4 w-full">
                                <vs-input class="w-full" data-vv-validate-on="blur" :label="$t('workShift.shiftName')" name="workShiftName"
                                          v-validate="'required'"
                                          v-model="item.name"/>
<!--                                <span class="text-danger text-sm">{{ errors.first('workShiftName') }}</span>-->
                            </div>
                            <div class="vx-col lg:w-1/2 md:w-1/2 w-1/2" style="min-width: 65%">
                                <label class="vs-input--label">{{$t('workShift.workingDay')}}</label>
                                <multiselect
                                    name="workDayOfWeek"
                                    data-vv-validate-on="input"
                                    v-model="item.workDayOfWeekObj"
                                    :options="workDayOfWeekOptions"
                                    group-values="libs"
                                    group-label="language"
                                    :group-select="true"
                                    :show-labels="false"
                                    :searchable="false"
                                    :multiple="true"
                                    :close-on-select="false"
                                    placeholder=""
                                    label="label"
                                    track-by="value"
                                    v-validate="'required'"
                                >
                                </multiselect>
                                <span class="text-danger text-sm">{{ errors.first('workDayOfWeek') }}</span>
                            </div>
                        </div>
                        <div class="vx-row md:mb-1 mb-4">
                            <div class="vx-col lg:w-1/6 md:w-1/2 w-1/2">
                                <label class="vs-input--label">{{$t('workShift.startTime')}}</label>
                                <v-select :value="item.startHourString" :clearable="false" :options="timeSpans"
                                          data-vv-validate-on="input"
                                          @input="startHour => updateTimeSpan(item, startHour, 'startHour')"
                                          v-validate="'required'"
                                          name="startHour">
                                    <span slot="no-options"> {{$t('menuOrganization.emptyList')}} </span>
                                </v-select>
<!--                                <span class="text-danger text-sm">{{ errors.first('startHour') }}</span>-->
                            </div>
                            <div class="vx-col lg:w-1/6 md:w-1/2 w-1/2">
                                <label class="vs-input--label">{{$t('workShift.endTime')}}</label>
                                <v-select :value="item.endHourString" :clearable="false" :options="timeSpans"
                                          data-vv-validate-on="input"
                                          @input="endHour => updateTimeSpan(item, endHour, 'endHour')"
                                          v-validate="'required'"
                                          name="endHour">
                                    <span slot="no-options"> {{$t('menuOrganization.emptyList')}} </span>
                                </v-select>
<!--                                <span class="text-danger text-sm">{{ errors.first('endHour') }}</span>-->
                            </div>
                            <div class="vx-col lg:w-1/4 md:w-1/2 w-1/2">
                                <vs-input class="w-full" :label="$t('workShift.flexible')" v-model="item.bufferTime"
                                          v-validate="'required|numeric'"
                                          name="bufferTime"/>
<!--                                <span class="text-danger text-sm">{{ errors.first('bufferTime') }}</span>-->
                            </div>
                            <div class="vx-col lg:w-1/4 md:w-1/2 w-1/2">
                                <label class="vs-input--label"></label>
                                <vs-checkbox style="line-height: 35px;" v-model="item.endInNextDay">{{$t('workShift.workThrough')}}
                                </vs-checkbox>
                            </div>
                            <div class="vx-col" style="padding-top: 30px">
                                <feather-icon icon="PlusIcon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                                              v-if="!isUpdate" @click="addNewRecord(index + 1)"/>
                            </div>
                            <div class="vx-col" style="padding-top: 30px">
                                <feather-icon icon="TrashIcon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                                              v-if="!isUpdate" @click="confirmDeleteRecord(index)"/>
                            </div>
                        </div>
                        <div class="vx-row md:mb-1 mb-4">

                            <div class="vx-col lg:w-1/5 md:w-1/2 w-1/2">
                                <vs-input class="w-full" :label="$t('workShift.allowAdvance')"
                                          v-validate="'required|numeric|max:4|min:1'"
                                          v-model="item.allowCheckInBefore" name="allowCheckInBefore"
                                          />
<!--                                <span class="text-danger text-sm">{{ errors.first('allowCheckInBefore') }}</span>-->
                            </div>
                            <div class="vx-col lg:w-1/5 md:w-1/2 w-1/2">
                                <vs-input class="w-full" :label="$t('workShift.allowInlater')"
                                          v-model="item.allowCheckInAfter" name="allowCheckInAfter"
                                          v-validate="'required|numeric|max:4|min:1'"
                                          />
<!--                                <span class="text-danger text-sm">{{ errors.first('allowCheckInAfter') }}</span>-->
                            </div>
                            <div class="vx-col lg:w-1/5 md:w-1/2 w-1/2">
                                <vs-input class="w-full" :label="$t('workShift.allowCheckOutIn')"
                                          v-model="item.allowCheckOutBefore" name="allowCheckOutBefore"
                                          v-validate="'required|numeric|max:4|min:1'"
                                          />
<!--                                <span class="text-danger text-sm">{{ errors.first('allowCheckOutBefore') }}</span>-->
                            </div>
                            <div class="vx-col lg:w-1/5 md:w-1/2 w-1/2">
                                <vs-input class="w-full" :label="$t('workShift.allowCheckOutLater')"
                                          v-model="item.allowCheckOutAfter" name="allowCheckOutAfter"
                                          v-validate="'required|numeric|max:4|min:1'"
                                          />
<!--                                <span class="text-danger text-sm">{{ errors.first('allowCheckOutAfter') }}</span>-->
                            </div>
                            <div class="vx-col lg:w-1/5 md:w-1/2 w-1/2">
                                <vs-input class="w-full" :label="$t('workShift.restTime')"
                                          v-model="item.restTime" name="allowCheckOutAfter"
                                          v-validate="'numeric|max:4|min:1'"
                                          />
<!--                                <span class="text-danger text-sm">{{ errors.first('allowCheckOutAfter') }}</span>-->
                            </div>
                        </div>

                       <div class="component w-full">
                            <div class="vx-row" v-if="!item.type">
                                <div class="vx-col w-full mt-4">
                                    <span class="font-bold">Chi tiết ca làm việc</span>
                                    <feather-icon class="ml-2" icon="PlusIcon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" style="vertical-align: middle;"
                                        @click="addNewRecordWorkShift(item.workShiftDetails, item.workShiftDetails.length)"/>
                                </div>
                            </div>

                            <div class="vx-row mt-2" v-for="(workShift, indexWorkShift) in item.workShiftDetails" :key="indexWorkShift">
                                <div class="vx-col md:w-5/12 w-full mt-2">
                                    <vs-input v-model="workShift.subWorkShiftName" class="w-full" label="Tên ca làm việc"></vs-input>
                                </div>
                                <div class="vx-col md:w-3/12 w-full mt-2">
                                    <vs-input type="time" v-model="workShift.startHour" class="w-full" label="Thời gian bắt đầu ca"></vs-input>
                                </div>
                                <div class="vx-col md:w-3/12 w-full mt-2">
                                    <vs-input v-model="workShift.endHour" type="time" class="w-full" label="Thời gian kết thúc ca"></vs-input>
                                </div>
                                <div class="vx-col md:w-1/12 w-full mt-8">
                                    <vs-button icon-pack='feather' icon='icon-trash' @click="deleteRecordWorkShift(item.workShiftDetails, indexWorkShift)"></vs-button>
                                </div>
                            </div>
                       </div>
                        <div class="vx-row md:mb-1 mb-4">
                            <br>
                        </div>
                    </div>

                    <!-- Save & Reset Button -->
                    <div class="vx-row">
                        <div class="vx-col w-full">
                            <div class="mt-8  mb-6 flex flex-wrap items-center justify-end">
                                <vs-button class="ml-auto mt-2" @click="saveChanges" v-if="(!isUpdate && isPermissionAdd()) || (isUpdate && isPermissionUpdate())"
                                           :disabled="!validateForm || workShiftSetting.length === 0">
                                    {{ isUpdate ? this.$t('button.update') : this.$t('button.add') }}
                                </vs-button>
                                <vs-button class="ml-4 mt-2" type="border" color="warning" @click="workShiftList">
                                    {{ $t('button.back') }}
                                </vs-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </vx-card>
    </div>
</template>
<style src="../../../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>

import utils from "../../../../components/utils";
import vSelect from 'vue-select';
import Multiselect from 'vue-multiselect';
import { isAPI } from "../../../../store/permission";
import { constAPI } from "../../../../store/constant";

export default {
    components: {
        vSelect,
        Multiselect
    },
    data() {
        return {
            indexWorkshift: 0,
            activeTab: 0,
            workShiftSetting: [{workShiftDetails:[]}],
            isUpdate: false,
            timeSpans: [],
            selectedWorkShiftItem: {},
            organizationBranchOptions: [],
            selectedOrganizationBranchValue: null,
            groupName: null,
            workDayOfWeekOptions: [
                {
                    language: 'Tất cả',
                    libs: [
                        {value: 2, label: 'Thứ 2'},
                        {value: 3, label: 'Thứ 3'},
                        {value: 4, label: 'Thứ 4'},
                        {value: 5, label: 'Thứ 5'},
                        {value: 6, label: 'Thứ 6'},
                        {value: 7, label: 'Thứ 7'},
                        {value: 1, label: 'Chủ nhật'}
                    ]
                }
            ]
        }
    },
    created() {
        let timeDuration = 30, timeSpans = [];
        for (let i = 0; i < 24 * 60; i = i + timeDuration) {
            timeSpans.push({value: i, label: utils.minuteToHour(i)});
        }
        this.timeSpans = timeSpans;
        this.initScreen();
    },
    computed: {
        validateForm() {
            return !this.errors.any()
        },

        selectedOrganizationBranch: {
            get() {
                return {
                    label: this.organizationBranchString(this.selectedOrganizationBranchValue),
                    value: this.selectedOrganizationBranchValue
                }
            },
            set(obj) {
                this.selectedOrganizationBranchValue = obj.value
            }
        }
    },
    methods: {
        isPermissionUpdate() {
            return isAPI(this, constAPI.work_shift_branch_edit)
        },
        isPermissionAdd() {
            return isAPI(this, constAPI.work_shift_branch_add)
        },
        deleteRecordWorkShift(arr, index){
            arr.splice(index, 1)
        },
        addNewRecordWorkShift(arr, index){
            index +=1;
            arr.splice(index, 0, {});
        },
        updateTimeSpan(setting, hour, type) {
            setting[type] = hour.value;
            setting[`${type}String`] = hour.label;
        },
        updateWorkDay(setting, workDay) {
            setting.workDayOfWeek = workDay.value;
        },
        organizationBranchString(id) {
            let organizationBranch = this.organizationBranchOptions.find(x => x.value === id);
            return (organizationBranch && organizationBranch.label) || this.$t('textCamera.undefined');
        },
        initScreen() {
            let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]')
            if (branchList.length == 0) {
                return this.$vs.notify({
                    text: this.$t('menuIntrusion.noBranch'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            this.organizationBranchOptions = branchList.map(item => {
                return {value: item.id, label: item.organizationBranchName}
            })
            let branchId = this.$route.query.branch_id;
            let index = 0;
            if (branchId) {
                index = this.organizationBranchOptions.findIndex(item => item.value == branchId)
            }
            this.selectedOrganizationBranch = this.organizationBranchOptions[index > -1 ? index : 0];
            this.loadSetting()
        },
        async saveChanges(evt) {
            evt.preventDefault();
            let checkForm = true;
            if (!this.validateForm) return;
            const result = await this.$validator.validateAll();
            if (!result) return checkForm = false;

            let isCheckValidate = true;
            let checkWorkShiftDetail = false;
            this.workShiftSetting.forEach(item => {
                if (item.workDayOfWeekObj) {
                    item.workDayOfWeek = item.workDayOfWeekObj.map(workDay => workDay.value)
                    item.endInNextDay = item.endInNextDay ? 1 : 0;
                    item.groupName = this.groupName
                    if (item.startHourString >= item.endHourString && item.endInNextDay == 0) isCheckValidate = false;
                }
                if (item.workShiftDetails.length > 0) {
                    item.workShiftDetails.forEach(el => {
                        if (el && el.startHour && el.endHour && el.subWorkShiftName) {
                            let arrayTimeStampStart = el.startHour.split(':');
                            let arrayTimeStampEnd = el.endHour.split(':');
                            el.startHour = (parseInt(arrayTimeStampStart[0], 10) * 60) + (parseInt(arrayTimeStampStart[1], 10))
                            el.endHour = (parseInt(arrayTimeStampEnd[0], 10) * 60) + (parseInt(arrayTimeStampEnd[1], 10))
                        }else {
                            checkWorkShiftDetail = true;
                        }
                    })
                }
            })
            if (!checkForm) return;
            if (!isCheckValidate) {
                return this.$vs.notify({
                    text: "Thời gian kết thúc phải lớn hơn thời gian bắt đầu. ",
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            let path = `/work-shift/organization/create/${this.selectedOrganizationBranchValue}`,
                data = this.workShiftSetting;
            if (this.isUpdate) {
                path = `/work-shift/organization/update/${this.$route.query.id}`;
                data = this.workShiftSetting[0];
            }
            if (checkWorkShiftDetail) {
                return this.$vs.notify({
                    text: "Chưa nhập thông tin chi tiết ca làm việc.",
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            this.$vs.loading();
            this.$crm.post(path, data).then(() => {
                this.$vs.notify({
                    color: 'success',
                    text: `${this.isUpdate ? 'Cập nhật' : 'Thêm'} thành công`,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                this.$vs.loading.close();
                this.$router.push(`/user/manage-branch-work-shift`).catch(() => {
                })
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Có lỗi xảy ra!',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        convertSecondsToTime: function(seconds){
            seconds = parseInt(seconds, 10);
            let hours = Math.floor(seconds / 60);
            let minutes = Math.floor((seconds - (hours * 60)));
            if (hours < 10) hours = "0" + hours;
            if (minutes < 10) minutes = "0" + minutes;
            return hours+ ':' + minutes;
        },
        loadSetting() {
            let id = this.$route.query.id;
            if (!id) {
                return
            }

            this.$vs.loading();
            let that = this;
            let patch = this.selectedOrganizationBranchValue ? '/work-shift/organization/find-by-organization-branch/' + this.selectedOrganizationBranchValue : '/work-shift/organization/find-by-organization-branch'
            this.$crm.post(patch).then((response) => {
                let workShiftSetting = response.data.workShiftSetting.filter(item => item.id == id).map(item => {
                    item.startHourString = this.timeSpans.find(timeSpan => timeSpan.value == item.startHour).label;
                    item.endHourString = this.timeSpans.find(timeSpan => timeSpan.value == item.endHour).label;
                    item.workDayOfWeekObj = this.workDayOfWeekOptions.filter(workDay => {
                        return item.workDayOfWeek.includes(workDay.value);
                    })
                    item.workShiftDetails.forEach(el => {
                        el.startHour = this.convertSecondsToTime(el.startHour);
                        el.endHour = this.convertSecondsToTime(el.endHour);
                    })
                    return item;
                });

                if (workShiftSetting.length > 0) {
                    this.isUpdate = true;
                    this.groupName = workShiftSetting[0].groupName
                }
                that.workShiftSetting = workShiftSetting;
                let result = this.workShiftSetting;
                this.workShiftSetting[0].workDayOfWeekObj = result[0].workDayOfWeek.map(el => {
                    let object = {}
                    if (el == 1) object['label'] = "Chủ nhật"; object['value'] = el;
                    if (el == 2) object['label'] = "Thứ hai"; object['value'] = el;
                    if (el == 3) object['label'] = "Thứ ba"; object['value'] = el;
                    if (el == 4) object['label'] = "Thứ tư"; object['value'] = el;
                    if (el == 5) object['label'] = "Thứ năm"; object['value'] = el;
                    if (el == 6) object['label'] = "Thứ sáu"; object['value'] = el;
                    if (el == 7) object['label'] = "Thứ bảy"; object['value'] = el;
                    return object;
                })
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        workShiftList() {
            this.$router.push(`/user/manage-branch-work-shift`).catch(() => {
            })
        },
        addNewRecord(index) {
            this.indexWorkshift += 1;
            this.workShiftSetting.splice(index, 0, {workShiftDetails: []})
        },
        confirmDeleteRecord(index) {
            this.selectedWorkShiftId = index;
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xoá`,
                text: `Bạn có chắc là muốn xoá`,
                accept: this.deleteRecord,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },
        deleteRecord() {
            this.workShiftSetting.splice(this.selectedWorkShiftId, 1)
        }
    },
}
</script>

<style lang="scss">
.work-shift-selected {
    .multiselect .multiselect__content-wrapper {
        max-height: 200px !important;
    }
}
</style>
